import { render } from "./hseHubProfileView.svg?vue&type=template&id=0999b211"
const script = {}
script.render = render

export default script